export const USER_POST_SIGNUP_REQUEST="USER_POST_SIGNUP_REQUEST";
export const USER_POST_SIGNUP_SUCESS="USER_POST_SIGNUP_SUCESS";
export const USER_POST_SIGNUP_FAILURE="USER_POST_SIGNUP_FAILURE";

export const USER_POST_SIGNIN_REQUEST="USER_POST_SIGNIN_REQUEST";
export const USER_POST_SIGNIN_SUCESS="USER_POST_SIGNIN_SUCESS";
export const USER_POST_SIGNIN_FAILURE="USER_POST_SIGNIN_FAILURE";

export const LOGOUT_USER="LOGOUT_USER";


